import { SxProps } from '@mui/material';

export const ContentRecommendationSkeletonSX: SxProps = {
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'flex-start',
	alignItems: 'flex-start',
	gap: '10px',
	marginTop: '40px',
	marginBottom: '20px',
};
